import { c as _c } from "react/compiler-runtime";
import { RadioGroup } from '@systemeio/ui';
import { getOfferTypeData } from 'modules/funnels/funnel/components/step-configuration-tab/offer-form-configuration-tab/utils/get-offer-type-data';
import { OfferTypeEnum } from 'modules/funnels/funnel/enums/offer-type-enum';
import React from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
interface OfferProductTypeSelectorProps {
  selected: OfferTypeEnum | undefined;
  className?: string;
  onChange: (value: OfferTypeEnum) => void;
}
const OfferProductTypeSelector = t0 => {
  const $ = _c(9);
  const {
    selected,
    onChange
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] !== t) {
    t1 = getOfferTypeData(t);
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const offerProductTypeData = t1;
  let t2;
  if ($[2] !== t) {
    t2 = t("dashboard.funnel.configuration.offer.choose_offer_type");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== offerProductTypeData || $[5] !== onChange || $[6] !== selected || $[7] !== t2) {
    t3 = <RadioGroup labelClassName="lg:text-[15px] text-sm font-normal text-text-primary pb-4" label={t2} optionsWrapperClassName="gap-0" optionWrapperClassName="py-4 lg:px-7 px-3" selectedOptionWrapperClassName="bg-[rgb(var(--brand-primary-subtle))] rounded-t-md" selectedOptionLabelClassName="bg-[rgb(var(--brand-primary-subtle))]" optionClassName="lg:text-[15px] text-sm font-normal text-text-primary" options={offerProductTypeData} selected={selected} onChange={onChange} />;
    $[4] = offerProductTypeData;
    $[5] = onChange;
    $[6] = selected;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};
export default OfferProductTypeSelector;